<form [formGroup]="bankAccountForm">
  <div class="row pt-3">
    <!-- bank account -->
    <div class="col-12 col-lg-6">
      <mat-form-field>
        <mat-label>Cuenta bancaria en CUP de 16 dígitos</mat-label>
        <input
          matInput
          placeholder="Cuenta bancaria*"
          mask="0000-0000-0000-0000"
          [showMaskTyped]="true"
          formControlName="number"
        />
        @if ( number.hasError('required') ) {
        <mat-error>El campo no puede ser vacío</mat-error>
        } @if ( number.hasError('pattern') ) {
        <mat-error>Formato incorrecto</mat-error>
        } @if ( number.hasError( 'bankAccountAlreadyExists' ) ) {
        <mat-error>
          Ya existe un socio con la cuenta bancaria especificada
        </mat-error>
        }
      </mat-form-field>
    </div>
    <!-- currency -->
    <div class="col-12 col-lg-6">
      <mat-form-field>
        <mat-label>Moneda</mat-label>
        <mat-select formControlName="currency">
          @for (c of currencies; track c) {
          <mat-option [value]="c">{{ c }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- bank agency -->
    <div class="col-12 col-lg-6">
      <mat-form-field>
        <mat-label>Agencia bancaria</mat-label>
        <mat-select formControlName="bank_agency">
          @for (ba of bankAgencies; track ba) {
          <mat-option [value]="ba">{{ ba }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- bank branch -->
    <div class="col-12 col-lg-6">
      <mat-form-field>
        <mat-label>Sucursal bancaria</mat-label>
        <input
          matInput
          placeholder="Sucursal bancaria*"
          formControlName="bank_branch"
        />
        @if ( bankBranch.hasError('required') ) {
        <mat-error>El campo no puede ser vacío</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</form>
